export default "__VITE_PUBLIC_ASSET__c647cba1__"